import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';
import AdminProtectedRoute from '../components/feature/AdminProtectedRoute';

// Lazy load pages
const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Help = lazy(() => import('../pages/help/page'));
const Safety = lazy(() => import('../pages/safety/page'));
const Search = lazy(() => import('../pages/search/page'));
const Profile = lazy(() => import('../pages/profile/page'));
const Messages = lazy(() => import('../pages/messages/page'));
const Matches = lazy(() => import('../pages/matches/page'));
const Premium = lazy(() => import('../pages/premium/page'));
const Stories = lazy(() => import('../pages/stories/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const Cookies = lazy(() => import('../pages/cookies/page'));
const Refund = lazy(() => import('../pages/refund/page'));
const Wedding = lazy(() => import('../pages/wedding/page'));
const Astrology = lazy(() => import('../pages/astrology/page'));
const ElitePage = lazy(() => import('../pages/elite/page'));
const Press = lazy(() => import('../pages/press/page'));
const Careers = lazy(() => import('../pages/careers/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Admin pages
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminSignup = lazy(() => import('../pages/admin/signup/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminUsers = lazy(() => import('../pages/admin/users/page'));
const AdminTransactions = lazy(() => import('../pages/admin/transactions/page'));
const AdminAnalytics = lazy(() => import('../pages/admin/analytics/page'));
const AdminPlans = lazy(() => import('../pages/admin/plans/page'));
const AdminCoupons = lazy(() => import('../pages/admin/coupons/page'));
const AdminReferrals = lazy(() => import('../pages/admin/referrals/page'));
const AdminBank = lazy(() => import('../pages/admin/bank/page'));
const AdminSettings = lazy(() => import('../pages/admin/settings/page'));
const AdminVerifications = lazy(() => import('../pages/admin/verifications/page'));
const PWASettings = lazy(() => import('../pages/admin/pwa-settings/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/help',
    element: <Help />,
  },
  {
    path: '/faq',
    element: <Help />,
  },
  {
    path: '/safety',
    element: <Safety />,
  },
  {
    path: '/search',
    element: <Search />,
  },
  {
    path: '/profile',
    element: (
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    ),
  },
  {
    path: '/messages',
    element: (
      <ProtectedRoute>
        <Messages />
      </ProtectedRoute>
    ),
  },
  {
    path: '/matches',
    element: <Matches />,
  },
  {
    path: '/premium',
    element: <Premium />,
  },
  {
    path: '/stories',
    element: <Stories />,
  },
  {
    path: '/press',
    element: <Press />,
  },
  {
    path: '/careers',
    element: <Careers />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/cookies',
    element: <Cookies />,
  },
  {
    path: '/refund',
    element: <Refund />,
  },
  {
    path: '/wedding',
    element: <Wedding />,
  },
  {
    path: '/astrology',
    element: <Astrology />,
  },
  {
    path: '/elite',
    element: (
      <ProtectedRoute>
        <ElitePage />
      </ProtectedRoute>
    ),
  },
  // Admin routes - completely separate
  {
    path: '/admin-login',
    element: <AdminLogin />,
  },
  {
    path: '/admin-signup',
    element: <AdminSignup />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin/signup',
    element: <AdminSignup />,
  },
  {
    path: '/admin/dashboard',
    element: (
      <AdminProtectedRoute>
        <AdminDashboard />
      </AdminProtectedRoute>
    ),
  },
  {
    path: '/admin/users',
    element: (
      <AdminProtectedRoute>
        <AdminUsers />
      </AdminProtectedRoute>
    ),
  },
  {
    path: '/admin/transactions',
    element: (
      <AdminProtectedRoute>
        <AdminTransactions />
      </AdminProtectedRoute>
    ),
  },
  {
    path: '/admin/analytics',
    element: (
      <AdminProtectedRoute>
        <AdminAnalytics />
      </AdminProtectedRoute>
    ),
  },
  {
    path: '/admin/plans',
    element: (
      <AdminProtectedRoute>
        <AdminPlans />
      </AdminProtectedRoute>
    ),
  },
  {
    path: '/admin/coupons',
    element: (
      <AdminProtectedRoute>
        <AdminCoupons />
      </AdminProtectedRoute>
    ),
  },
  {
    path: '/admin/referrals',
    element: (
      <AdminProtectedRoute>
        <AdminReferrals />
      </AdminProtectedRoute>
    ),
  },
  {
    path: '/admin/bank',
    element: (
      <AdminProtectedRoute>
        <AdminBank />
      </AdminProtectedRoute>
    ),
  },
  {
    path: '/admin/settings',
    element: (
      <AdminProtectedRoute>
        <AdminSettings />
      </AdminProtectedRoute>
    ),
  },
  {
    path: '/admin/verifications',
    element: (
      <AdminProtectedRoute>
        <AdminVerifications />
      </AdminProtectedRoute>
    ),
  },
  {
    path: '/admin/pwa-settings',
    element: (
      <AdminProtectedRoute>
        <PWASettings />
      </AdminProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
